import React, { useEffect, useState, useRef } from "react";
import Select, { components } from "react-select";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2/dist/js/select2.min";
import bannerImage from "../assets/img/ban1.jpg";
import logoImage from "../assets/img/logo.png";
import whiteLogoImage from "../assets/img/white-logo.png";
import frameImage from "../assets/img/Frame.svg";
import image1002 from "../assets/img/image 1002.svg";
import rectangle23 from "../assets/img/Rectangle23.jpg";
import dummyImage from "../assets/img/dummyimage.png";
import checkBlue from "../assets/img/checkblue.png";
import ceoRank from "../assets/img/ceorank.png";
import surveysIcon from "../assets/img/surveysicon.png";
import startImg from "../assets/img/star.svg";

import "../assets/css/style.css";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { toast } from "react-toastify";

const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "40px",
    overflowX: "auto",
    flexWrap: "nowrap",
  }),
  valueContainer: (provided) => ({
    ...provided,
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
    scrollbarWidth: "none",
  }),
  multiValue: (provided) => ({
    ...provided,
    flex: "0 0 auto",
  }),
};

// Custom ValueContainer to show only first 3 selected options
const CustomValueContainer = ({ children, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxVisible = 3;

  const [values, input] = children;
  const selected = props.getValue();

  let displayValues = values;
  let hiddenCount = 0;

  if (!isExpanded && selected.length > maxVisible) {
    displayValues = values.slice(0, maxVisible);
    hiddenCount = selected.length - maxVisible;
  }

  return (
    <components.ValueContainer {...props}>
      {displayValues}
      {!isExpanded && hiddenCount > 0 && (
        <div
          onClick={() => setIsExpanded(true)}
          style={{
            padding: "2px 8px",
            margin: "2px",
            borderRadius: "4px",
            backgroundColor: "#e2e6ea",
            fontSize: "12px",
            cursor: "pointer",
            flex: "0 0 auto",
          }}
        >
          +{hiddenCount} more
        </div>
      )}
      {input}
    </components.ValueContainer>
  );
};

const Survey = () => {
  const navigate = useNavigate();
  const { firstName, lastName } = useCurrentUser();

  const [activeTab, setActiveTab] = useState("all");
  const [selectedQuestion, setSelectedQuestion] = useState(0);

  const [surveyTitle, setSurveyTitle] = useState("");
  const [surveyDescription, setSurveyDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [sector, setSector] = useState([]); // Raw API data
  const [selectedSector, setSelectedSector] = useState([]); // User selections
  const [industry, setIndustry] = useState([]); // Raw API data from API
  const [selectedIndustry, setSelectedIndustry] = useState([]); // User-selected values
  const [region, setRegion] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [mysurvey, setMysurvey] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [timer, setTimer] = useState(5 * 3600 + 20 * 60); // 05:20:00 in seconds
  const [surveyFilter, setSurveyFilter] = useState("all"); // Changed default to "all" to show all surveys
  const [searchQuery, setSearchQuery] = useState("");
  const [showMenu, setShowMenu] = useState(null);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null); // Track open dropdown
  const questionListRef = useRef([]);
  const select2Initialized = useRef(new Set()); // Track initialized Select2 elements

  // working with file selection

  // One state varible for survey data start

  const initialSurveyData = {
    survey_title: "",
    survey_description: "",
    survey_image: null,
    target_sector: [],
    target_industry: [],
    target_region: [],
    target_country: [],
    start_date: "",
    end_date: "",
    questions: [{ question: "", question_type: "openend", options: [] }],
  };

  const [surveyData, setSurveyData] = useState({
    ...initialSurveyData,
  });

  useEffect(() => {
    console.log("🔹 STEP 5 — useEffect ran after surveyData update:", mysurvey);
  }, [mysurvey]);

  const resetSurvey = () => {
    setSurveyData({
      survey_title: "",
      survey_description: "",
      survey_image: null,
      target_sector: [],
      target_industry: [],
      target_region: [],
      target_country: [],
      start_date: "",
      end_date: "",
      status: "",
      questions: [{ question: "", question_type: "openend", options: [] }],
    });
    setPreview(null); // clear preview separately
  };

  const [dropdownData, setDropdownData] = useState({
    sectors: [],
    industries: [],
    regions: [],
    countries: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
    sector: "",
    industry: "",
    region: "",
    country: "",
  });

  const updateFiled = (field, value) => {
    setSurveyData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  // One state varible for survey data end

  const fileInputRef = useRef(null);

  // Sample survey data for "My Survey" tab
  const surveys = [
    {
      id: 1,
      status: "active",
      postedDate: "16 Aug 2025",
      postedTime: "08:29am",
      title: "Customer Feedback Survey 2025",
      description:
        "Your feedback helps us improve. Please take a moment to share your thoughts!",
      questions: [
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
      ],
      views: 22000,
      participants: 300,
    },
    {
      id: 2,
      status: "draft",
      title: "Customer Feedback Survey 2025",
      description:
        "Your feedback helps us improve. Please take a moment to share your thoughts!",
      questions: [
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
      ],
    },
    {
      id: 3,
      status: "closed",
      postedDate: "16 Aug 2025",
      postedTime: "08:29am",
      title: "Customer Feedback Survey 2025",
      description:
        "Your feedback helps us improve. Please take a moment to share your thoughts!",
      questions: [
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
        "What song was or do you want to be your first dance at your wedding?",
      ],
      likes: 22000,
      shares: 145,
    },
  ];

  // Sample data for "Survey for me" tab
  const surveyForMeQuestions = [
    {
      text: "What is Your Highest Education?",
      options: [
        "Middle School",
        "Matriculation (10th)",
        "Intermediate (12th)",
        "Diploma (Polytechnic)",
      ],
    },
    {
      text: "What is your highest level of education? (Single select/drop-down)",
      options: [
        "Middle School",
        "Matriculation (10th)",
        "Intermediate (12th)",
        "Diploma (Polytechnic)",
      ],
    },
    {
      text: "What is your address?",
      options: [],
    },
  ];

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", {
        state: { errorMessage: "Please log in to access this page." },
      });
    }
  }, [navigate]);

  // Initialize and cleanup Select2 for "Create Survey" tab
  useEffect(() => {
    if (activeTab === "create-survey") {
      const $selects = $("#create-survey .form-select");
      $selects.each(function () {
        const $this = $(this);
        if (!$this.hasClass("select2-hidden-accessible")) {
          $this.select2({
            placeholder: $this.data("placeholder") || "Select",
            allowClear: true,
            width: "100%",
          });
          select2Initialized.current.add(this);
        }
      });
    }

    return () => {
      select2Initialized.current.forEach((element) => {
        try {
          $(element).select2("destroy");
        } catch (err) {
          console.warn("Failed to destroy Select2 instance:", err);
        }
      });
      select2Initialized.current.clear();
    };
  }, [activeTab]);

  // Timer logic for "Survey for me" tab
  useEffect(() => {
    if (activeTab === "survey-for-me" && showSurvey) {
      const timerInterval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 0) {
            clearInterval(timerInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timerInterval);
    }
  }, [activeTab, showSurvey]);

  // Handle survey menu toggle
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".surveymenu")) {
        setShowMenu(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // useeffect for call the function to get data on mount
  useEffect(() => {
    getSectors();
    getIndustries();
    getCountries();
    MySurvey();
  }, []);

  // function to get the sectors api data.
  const getSectors = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/sectors`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status == 200) {
        setSector(response.data.data);
        // console.log(response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  // function to get the industries api data.
  const getIndustries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/industries`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status == 200) {
        setIndustry(response.data.data);
        // console.log(response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  // function to get the country data
  const getCountries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/industries`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status == 200) {
        setCountry(response.data.data);
        setRegion(response.data.data);
        // console.log(response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  //  function to get mysurvey data
  const MySurvey = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/mysurvey`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status == 200) {
        setMysurvey(response.data.data);
        // setRegion(response.data.data);
        // console.log(response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  const formatTime = (totalSeconds) => {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const handleMultiSelect = (event, setState) => {
    const options = [...event.target.selectedOptions].map((opt) => opt.value);
    setState(options);
  };

  // const handleFileUpload = (e) => {
  //   const uploadedFile = e.target.files[0];
  //   if (uploadedFile) {
  //     setFile(uploadedFile);
  //     setPreview(URL.createObjectURL(uploadedFile));
  //   }
  // };

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0] || null;
    if (!file) return;

    setSurveyData((prev) => ({
      ...prev,
      survey_image: file,
    }));
    setPreview(URL.createObjectURL(file));
  };

  const handleRemoveFile = () => {
    setSurveyData((prev) => ({
      ...prev,
      survey_image: null,
    }));
    setPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleOpenSurvey = () => {
    setShowSurvey(true);
    setShowThankYou(false);
  };

  const handleNext = () => {
    if (selectedQuestion < surveyForMeQuestions.length - 1) {
      setSelectedQuestion(selectedQuestion + 1);
    }
  };

  const handlePrev = () => {
    if (selectedQuestion > 0) {
      setSelectedQuestion(selectedQuestion - 1);
    }
  };

  const handleSubmitSurvey = () => {
    setShowThankYou(true);
    setShowSurvey(false);
  };

  const handleBackToPrevious = () => {
    setShowThankYou(false);
    setShowSurvey(false);
  };

  const DEFAULT_QUESTION = {
    question: "",
    question_type: "openend",
    options: [],
  };

  const addNewQuestion = () => {
    setSurveyData((prev) => ({
      ...prev,
      questions: [...prev.questions, { ...DEFAULT_QUESTION }],
    }));
  };

  const cloneQuestion = (index) => {
    setSurveyData((prev) => {
      const newQuestions = [...prev.questions];
      newQuestions.splice(index + 1, 0, {
        ...prev.questions[index],
        question: "", // reset question text
        options: [], // reset options
      });
      return { ...prev, questions: newQuestions };
    });
  };

  const deleteQuestion = (index) => {
    setSurveyData((prev) => {
      if (prev.questions.length > 1) {
        return {
          ...prev,
          questions: prev.questions.filter((_, i) => i !== index),
        };
      }
      return prev;
    });
  };

  const updateQuestion = (index, field, value) => {
    const newQuestions = [...surveyData.questions];

    // If changing question_type to singleChoice or multipleChoice
    if (
      field === "question_type" &&
      ["singleChoice", "multipleChoice"].includes(value) &&
      newQuestions[index].options.length === 0
    ) {
      newQuestions[index][field] = value;
      newQuestions[index].options = ["", ""]; // start with 2 blank options
    }
    // If updating options (array-based approach)
    else if (field === "options") {
      if (
        ["singleChoice", "multipleChoice"].includes(
          newQuestions[index].question_type
        ) &&
        Array.isArray(value)
      ) {
        newQuestions[index][field] = [...value]; // Directly assign array
      }
    }
    // For all other fields
    else {
      newQuestions[index][field] = value;
    }

    setSurveyData({
      ...surveyData,
      questions: newQuestions,
    });
  };

  const handleAddOption = (index) => {
    setSurveyData((prev) => {
      const newQuestions = [...prev.questions];
      newQuestions[index].options = [...newQuestions[index].options, ""];
      return {
        ...prev,
        questions: newQuestions,
      };
    });
  };

  const handleRemoveOption = (index, optIndex) => {
    setSurveyData((prev) => {
      const newQuestions = [...prev.questions];
      newQuestions[index].options = newQuestions[index].options.filter(
        (_, i) => i !== optIndex
      );
      return {
        ...prev,
        questions: newQuestions,
      };
    });
  };

  const formatTargetFields = (data) => {
    const fields = [
      "target_sector",
      "target_industry",
      "target_region",
      "target_country",
    ];
    const result = {};

    fields.forEach((field) => {
      if (data[field] && data[field].length > 0) {
        result[field] = data[field]
          .map((item) => item.answer)
          .join(", ")
          .replace(/,\s*$/, "");
      }
    });

    return result;
  };

  const handleSubmit2 = async (e, status) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log("Survey Data:", surveyData);
      // Convert the array fields into comma-separated strings
      const formattedTargets = formatTargetFields(surveyData);

      const payload = {
        ...surveyData,
        ...formattedTargets,
        survey_image: surveyData.survey_image?.name || null,
        status: status,
      };
      console.log("status", status);
      console.log(
        "Prepared payload for API:",
        payload,
        "payload1",
        payload.surveyData
      );
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/createSurvey`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Survey Created:", response);
      console.log("Survey Created:", response.data);
      if (response.status === 201) {
        toast.success("Survey created successfully!");
        setSurveyData(initialSurveyData);
        setLoading(false);
        setPreview(null);
      } else {
        toast.error("Error creating survey please try again");
      }

      console.log("Prepared payload for API:", payload);
    } catch (err) {
      console.error("Survey Creation Error:", err);
      setError(
        err.response?.data?.message ||
        "Failed to create survey. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const toggleMenu = (surveyId, e) => {
    e.stopPropagation();
    setShowMenu(showMenu === surveyId ? null : surveyId);
  };

  const renderQuestionOptions = (question, index) => {
    switch (question.question_type) {
      case "multipleChoice":
      case "singleChoice":
        return (
          <div className="answers_options_box">
            {question.options.map((option, optIndex) => (
              <div className="answer_option" key={optIndex}>
                <div className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    className="form-control me-2 mt-0"
                    placeholder="Answer option label / image"
                    value={option}
                    onChange={(e) => {
                      const newOptions = [...question.options];
                      newOptions[optIndex] = e.target.value;
                      updateQuestion(index, "options", newOptions);
                    }}
                  />
                  <span className="me-2 cursor-pointer add_image_answer_option">
                    <i className="bi bi-image"></i>
                  </span>
                  <span
                    className="cursor-pointer remove_answer_option"
                    onClick={() => handleRemoveOption(index, optIndex)}
                  >
                    <i className="bi bi-x ft-22"></i>
                  </span>
                </div>
              </div>
            ))}
            <div className="text-start mt-4">
              <button
                type="button"
                className="btn-dark d-inline-block rounded-3 p-2 ft-13 add_answer_option"
                onClick={() => handleAddOption(index)}
              >
                <i className="bi bi-plus"></i> Add Option
              </button>
            </div>
          </div>
        );

      case "ratings":
        return (
          <div className="answers_options_box">
            <div className="answer_option ratings_options ft-24 mt-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <i
                  key={i}
                  className="bi bi-star"
                  data-index={i}
                  onMouseEnter={(e) => {
                    const parent = e.currentTarget.parentElement;
                    Array.from(parent.children).forEach((el, idx) => {
                      if (idx < i) {
                        el.classList.remove("bi-star");
                        el.classList.add("bi-star-fill");
                      } else {
                        el.classList.remove("bi-star-fill");
                        el.classList.add("bi-star");
                      }
                    });
                  }}
                  onMouseLeave={(e) => {
                    const parent = e.currentTarget.parentElement;
                    Array.from(parent.children).forEach((el) => {
                      el.classList.remove("bi-star-fill");
                      el.classList.add("bi-star");
                    });
                  }}
                ></i>
              ))}
            </div>
          </div>
        );
      case "scaling":
        return (
          <div className="answers_options_box">
            <div className="answer_option slider_option mt-4">
              <div className="position-relative mb-4">
                <input
                  type="range"
                  className="form-range"
                  min="1"
                  max="5"
                  step="1"
                  id={`ratingRange-${index}`}
                />
                <div
                  className="d-flex justify-content-between position-absolute w-100"
                  style={{ top: "20px" }}
                >
                  <span>😠</span>
                  <span>😕</span>
                  <span>😐</span>
                  <span>🙂</span>
                  <span>🤩</span>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div id="wrapper">
        <section
          id="banner"
          style={{
            minHeight: "480px",
            background: `url(${bannerImage}) center left no-repeat`,
            backgroundSize: "cover",
          }}
          className="d-flex py-5"
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7 mx-auto pt-5">
                <div className="text-center pt-5">
                  <h1 className="text-white display2 mb-3 fw-700">
                    Contribute to Insights, Shape the Future
                  </h1>
                  <h4 className="fw-400 text-white cbcbcb lh-26">
                    Participate in surveys to earn rewards, or create your own
                    to gather valuable insights and drive change. Empower
                    yourself with the data you need, while contributing to
                    industry knowledge.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="inner_section">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-xl-4">
                <aside id="asidebar_inner" className="ft-15 lh-22">
                  <div className="first_box card_box">
                    <div className="d-flex gap-3 align-items-center">
                      <div>
                        <img src={frameImage} alt="Bonus Icon" />
                      </div>
                      <div className="ft-20 lh-22">Bonus Items</div>
                    </div>
                  </div>
                  <div className="card_box">
                    <div className="d-flex gap-3 align-items-start">
                      <div>
                        <img src={image1002} alt="Bonus Image" />
                      </div>
                      <div className="d-flex flex-wrap gap-3">
                        <h3 className="ft-20 lh-26 fw-700">
                          Congratulations! you have received Joining Bonus Coins
                        </h3>

                        <div className="samplecoines d-flex gap-4 rounded-3 p-3 mb-2">
                          <div className="ft-15 fw-500">Sample Coins</div>
                          <div className="d-flex gap-2 ft-15 fw-500">
                            {" "}
                            <img src={startImg} alt="" /> <span>100</span>
                          </div>
                        </div>

                        <p>
                          Take the next step to get opportunities surfaced
                          faster than ever.
                        </p>
                        <div className="progress w-100">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: "25%" }}
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <p>25% completed</p>
                      </div>
                    </div>
                  </div>
                  <div className="card_box gap-1rem">
                    <h4 className="ft-20 lh-26 fw-500">
                      Use Your Coins to Create Surveys
                    </h4>
                    <p>
                      Put your earned coins to work by building insightful
                      surveys tailored to your needs.
                    </p>

                    <div className="samplecoines d-flex gap-4 rounded-3 p-3 mb-2">
                      <div className="ft-15 fw-500">You have currently</div>
                      <div className="d-flex gap-2 ft-15 fw-500">
                        {" "}
                        <img src={startImg} alt="" />{" "}
                        <span>50 coins available.</span>
                      </div>
                    </div>

                    <div className="w-100 clearfix"></div>
                    <div className="text-end mt-4">
                      <a href="#" className="purple_outline_btn d-inline-block">
                        Buy Now <i className="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </div>
                </aside>
              </div>
              <div className="col-lg-8">
                <div className="inner_wrapper card_box py-5">
                  <ul className="nav nav-tabs nav-justified fw-600 border-0">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === "all" ? "active" : ""
                          }`}
                        href="#all"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("all");
                        }}
                      >
                        All
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === "survey-for-me" ? "active" : ""
                          }`}
                        href="#survey-for-me"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("survey-for-me");
                        }}
                      >
                        Survey for me
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === "my-survey" ? "active" : ""
                          }`}
                        href="#my-survey"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("my-survey");
                        }}
                      >
                        My Survey
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === "create-survey" ? "active" : ""
                          }`}
                        href="#create-survey"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("create-survey");
                        }}
                      >
                        Create Survey
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content pt-3">
                    <div
                      className={`tab-pane fade ${activeTab === "all" ? "show active" : ""
                        }`}
                      id="all"
                    >
                      <div className="user-info d-flex align-items-center gap-3">
                        <img src={dummyImage} alt="User" />
                        <div>
                          <div className="name fw-bold">{`${firstName} ${lastName}`}</div>
                          <div className="time text-muted">08:39 am</div>
                        </div>
                      </div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse.
                      </p>



                      <div className="image-wrapper animate-fade-in">
                        <img
                          src={rectangle23}
                          className="w-100 mt-4"
                          alt="Cityscape"
                        />
                      </div>


                      <div className="poll-containers">
                        <div className="d-flex align-items-center justify-content-between mt-5">
                          <div className="d-flex gap-3 ft-14 fw-400 text-muted">
                            <div>• 22k View</div>
                            <div>• 300 Participate</div>
                          </div>
                          <Link
                            href="#"
                            className="btn btn-dark rounded-3 ft-15 text-decoration-none"
                            onClick={handleOpenSurvey}
                          >
                            Open Survey
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "survey-for-me" ? "show active" : ""
                        }`}
                      id="survey-for-me"
                    >
                      <div className="poll-containers">
                        {!showSurvey && !showThankYou && (
                          <div className="opensurvey_container">
                            <div className="poll-question">
                              <div className="user-info d-flex align-items-center gap-3">
                                <img src={dummyImage} alt="User" />
                                <div>
                                  <div className="name fw-bold">
                                    Loggedin Username
                                  </div>
                                  <div className="time text-muted">
                                    08:39 am
                                  </div>
                                </div>
                              </div>
                              <p>
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation.
                              </p>
                            </div>
                            <div className="mt-4 poll-questions">
                              {surveyForMeQuestions.map((question, index) => (
                                <div
                                  key={index}
                                  className="poll-question-option"
                                >
                                  {`Q${index + 1}. ${question.text}`}
                                </div>
                              ))}
                            </div>

                            <div className="poll-containers">
                              <div className="text-muted mt-3 d-flex align-items-center gap-3 ft-14 fw-400 mt-4">
                                <div className="like-container likered">
                                  <label>
                                    <input
                                      type="checkbox"
                                      className="like-toggle"
                                    />
                                    <i className="fa-solid fa-heart"></i>
                                  </label>
                                  <span className="like-count">22,000 •</span>
                                </div>
                                <div className="share-container">
                                  <a href="#">
                                    <i className="fa-solid fa-share"></i>
                                    <span>145 shares</span>
                                  </a>
                                </div>
                                <div> • Poll Closed</div>
                              </div>
                            </div>

                            {/* <div className="text-muted mt-3 d-flex align-items-center gap-3 ft-14 fw-400 mt-4">
                              <div className="like-container save-container">
                                <label>
                                  <input type="checkbox" className="save-toggle" />
                                  <i className="fa-solid fa-bookmark ft-24"></i> Save
                                </label>
                              </div>
                              <div>• 22k View</div>
                              <div>• 300 Participate</div>
                            </div> */}

                            {/* <div className="text-center mt-4">
                              <Link
                                href="#"
                                className="btn btn-dark btn-rounded ft-15 fw-600 py-2 px-4"
                                onClick={handleOpenSurvey}
                              >
                                Open Survey
                              </Link>
                            </div> */}
                          </div>
                        )}
                        {(showSurvey || showThankYou) && (
                          <div className="mt-4 poll-survey">
                            {!showThankYou && (
                              <>
                                <div className="survey_section_steps">
                                  {surveyForMeQuestions.map(
                                    (question, index) => (
                                      <div
                                        key={index}
                                        className={`survey_section ${index === selectedQuestion
                                            ? "active"
                                            : ""
                                          }`}
                                      >
                                        <h4 className="ft-14 fw-700 mb-3">
                                          {`Q${index + 1} ${question.text}`}
                                        </h4>
                                        <div className="poll_survey_options">
                                          {question.options.map(
                                            (option, optIndex) => (
                                              <div
                                                key={optIndex}
                                                className="custom_checkradio mb-3"
                                              >
                                                <label>
                                                  <input
                                                    type="radio"
                                                    name={`education-${index}`}
                                                  />{" "}
                                                  {option}
                                                </label>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                                <div className="survey_bullets pt-5">
                                  <div className="d-flex justify-content-between align-items-end">
                                    <div className="d-flex bullet_flex gap-1">
                                      {surveyForMeQuestions.map((_, index) => (
                                        <span
                                          key={index}
                                          className={`bullets ${index <= selectedQuestion
                                              ? "active"
                                              : ""
                                            }`}
                                        ></span>
                                      ))}
                                    </div>
                                    <div className="d-flex gap-3">
                                      <div className="timer_flex d-flex align-items-center gap-2 ft-14">
                                        <i className="bi bi-stopwatch ft-20"></i>
                                        <div className="lh-16">
                                          <div
                                            id="timer_countdown"
                                            className="fw-bold"
                                          >
                                            {formatTime(timer)}
                                          </div>
                                          <p>Time Remaining</p>
                                        </div>
                                      </div>
                                      <div>
                                        <button
                                          onClick={handlePrev}
                                          className="prevbullet btn btn-outline-dark btn-rounded ft-15 fw-600 py-2 px-4"
                                          style={{
                                            display:
                                              selectedQuestion === 0
                                                ? "none"
                                                : "inline-block",
                                          }}
                                        >
                                          Prev Question
                                        </button>
                                        <button
                                          onClick={handleNext}
                                          className="nextbullet btn btn-dark btn-rounded ft-15 fw-600 py-2 px-4"
                                          style={{
                                            display:
                                              selectedQuestion ===
                                                surveyForMeQuestions.length - 1
                                                ? "none"
                                                : "inline-block",
                                          }}
                                        >
                                          Next Question
                                        </button>
                                        <button
                                          onClick={handleSubmitSurvey}
                                          className="submitbullet btn btn-dark btn-rounded ft-15 fw-600 py-2 px-5"
                                          style={{
                                            display:
                                              selectedQuestion ===
                                                surveyForMeQuestions.length - 1
                                                ? "inline-block"
                                                : "none",
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {showThankYou && (
                              <div className="thankyouarea">
                                <div className="text-center">
                                  <div>
                                    <img
                                      src={checkBlue}
                                      style={{ width: "75px" }}
                                      alt="Checkmark"
                                    />
                                  </div>
                                  <div>
                                    <b>
                                      Thank you for taking the time to
                                      participate in our survey.
                                    </b>
                                    <br />
                                    Your feedback is greatly appreciated and
                                    valuable to us.
                                  </div>
                                </div>
                                <div className="text-end mt-5">
                                  <a
                                    href="#"
                                    className="btn btn-dark btn-rounded ft-15 fw-600 py-2 px-3"
                                    onClick={handleBackToPrevious}
                                  >
                                    <i className="bi bi-arrow-left-short"></i>{" "}
                                    Back to Previous page
                                  </a>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "my-survey" ? "show active" : ""
                        }`}
                      id="my-survey"
                    >
                      <div className="search-containers">
                        <div className="searchsurveysbox">
                          <form className="position-relative search_aside">
                            <i className="bi bi-search"></i>
                            <input
                              type="text"
                              className="form-control m-0"
                              placeholder="search"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </form>
                        </div>
                        <div className="surveysbtn">
                          {/* <img src={surveysIcon} className="icon-left" alt="Surveys Icon" /> */}
                          <i class="bi bi-filter icon-left"></i>
                          <select
                            className="bg-img"
                            value={surveyFilter}
                            onChange={(e) => setSurveyFilter(e.target.value)}
                          >
                            <option value="all">All Surveys</option>{" "}
                            {/* Added "All Surveys" option */}
                            <option value="livesurveys">Live Surveys</option>
                            <option value="draftsurveys">Draft Surveys</option>
                            <option value="closedsurveys">
                              Closed Surveys
                            </option>
                          </select>
                          <div className="icon-right">
                            <i className="bi bi-chevron-down"></i>
                          </div>
                        </div>
                      </div>
                      {mysurvey.map((survey) => (
                        <div className="surveylist" key={survey.survey_id}>
                          <div className="topdatetimerow d-flex justify-content-between align-items-center">
                            {survey.status == 1 && (
                              <div className="surveydatetime d-flex align-items-center gap-2 ft-15 fw-400">
                                <span>Posted Date:</span>
                                <div>
                                  {" "}
                                  {new Date(
                                    survey.created_on
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })}
                                </div>
                                {/* <div>|</div> */}
                                {/* <div>{survey.postedTime}</div> */}
                              </div>
                            )}
                            <div className="btnactiedraft d-flex align-items-center gap-4">
                              <div className="surveybtn">
                                <span
                                  className={`activebtn btn ${survey.status === 1 ? "" : "d-none"
                                    }`}
                                >
                                  Active
                                </span>
                                <span
                                  className={`draftbtn btn ${survey.status === 2 ? "" : "d-none"
                                    }`}
                                >
                                  Draft
                                </span>
                                <span
                                  className={`closedbtn btn ${survey.status === null ? "" : "d-none"
                                    }`}
                                >
                                  Closed
                                </span>
                              </div>
                              <div
                                className="surveymenu"
                                onClick={(e) => toggleMenu(survey.survey_id, e)}
                              >
                                <i class="bi bi-three-dots"></i>
                                {showMenu === survey.survey_id && (
                                  <div className="surveymenuname">
                                    <ul>
                                      <li>
                                        <a href="javascript:void(0);">Active</a>
                                      </li>
                                      <li>
                                        <a href="javascript:void(0);">Draft</a>
                                      </li>
                                      <li>
                                        <a href="javascript:void(0);">Closed</a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="feedbackheading d-flex">
                            <div className="feedbackimg">
                              <img
                                src={survey.survey_image || ceoRank}
                                alt="feedbackimg"
                              />
                            </div>
                            <div className="feedbacktext">
                              <h3>{survey.survey_title}</h3>
                              <p>{survey.survey_description}</p>
                            </div>
                          </div>

                          <div className="feedbacklistrow">
                            <ul>
                              {survey.questions.map((question, index) => (
                                <li key={index}>
                                  <p className="ques">Question {index + 1}</p>
                                  <p>{question.question}</p>
                                </li>
                              ))}
                            </ul>
                          </div>

                          {/* <div className="participatebox d-flex align-items-center gap-3 ft-15 fw-400">
                              {survey.status === "active" && (
                                <>
                                  <div>
                                    {survey.views.toLocaleString()} View
                                  </div>
                                  <div>
                                    {" "}
                                    • {survey.participants} Participate
                                  </div>
                                </>
                              )}
                              {survey.status === "closed" && (
                                <div className="poll-containers">
                                  <div className="text-muted mt-3 d-flex align-items-center gap-3 ft-14 fw-400 mt-4">
                                    <div className="like-container likered">
                                      <label>
                                        <input
                                          type="checkbox"
                                          className="like-toggle"
                                        />
                                        <i className="fa-solid fa-heart"></i>
                                      </label>
                                      <span className="like-count">
                                        {survey.likes.toLocaleString()} •
                                      </span>
                                    </div>
                                    <div className="share-container">
                                      <a href="#">
                                        <i className="fa-solid fa-share"></i>
                                        <span>{survey.shares} shares</span>
                                      </a>
                                    </div>
                                    <div> • Poll Closed</div>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="create_survey_button_box d-flex justify-content-end align-items-center">
                              <div className="d-flex gap-3">
                                {survey.status === "active" && (
                                  <>
                                    <Link
                                      href="javascript:void(0);"
                                      className="btn btn-outline-dark text-decoration-none preview_survey rounded-3 ft-15 d-flex justify-content-center align-items-center"
                                    >
                                      Close Your Survey
                                    </Link>
                                    <Link
                                      href="javascript:void(0);"
                                      className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                                    >
                                      View Response
                                    </Link>
                                  </>
                                )}
                                {survey.status === "draft" && (
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                                  >
                                    Go Live
                                  </a>
                                )}
                                {survey.status === "closed" && (
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                                  >
                                    View Response
                                  </a>
                                )}
                              </div>
                            </div> */}
                        </div>
                      ))}
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "create-survey" ? "show active" : ""
                        }`}
                      id="create-survey"
                    >
                      {error && (
                        <div
                          className="alert alert-danger text-center"
                          role="alert"
                        >
                          {error}
                        </div>
                      )}
                      <form onSubmit={(e) => handleSubmit2(e, 1)}>
                        <div className="mb-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Survey Title"
                            value={surveyData.survey_title}
                            onChange={(e) =>
                              updateFiled("survey_title", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Survey Description"
                            value={surveyData.survey_description}
                            onChange={(e) =>
                              updateFiled("survey_description", e.target.value)
                            }
                          />
                        </div>
                        <div className="uploaded-files">
                          <label className="form-label">
                            Add Question Image
                          </label>

                          <div className="custom-file-upload">
                            <button
                              type="button"
                              onClick={() => fileInputRef.current?.click()}
                            >
                              Upload File
                            </button>
                            <span className="file-name">
                              {surveyData.survey_image?.name ||
                                "No file chosen"}
                            </span>
                            <input
                              type="file"
                              ref={fileInputRef}
                              className="form-control mt-0"
                              accept="image/*,video/*"
                              onChange={handleFileUpload}
                              style={{ display: "none" }}
                            />
                          </div>

                          {preview && (
                            <div className="preview-container mt-2">
                              <div className="preview-wrapper">
                                {surveyData.survey_image.type.startsWith(
                                  "image/"
                                ) ? (
                                  <img
                                    src={preview}
                                    alt="Preview"
                                    className="img-thumbnail"
                                    style={{ maxWidth: "200px" }}
                                  />
                                ) : (
                                  <video controls width="200">
                                    <source src={preview} type={file.type} />
                                    Your browser does not support the video tag.
                                  </video>
                                )}
                                <button
                                  className="btn btn-sm btn-danger mt-2"
                                  onClick={handleRemoveFile}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label mt-0">
                            Target Audience
                          </label>
                          <div className="row">
                            {/* sector  */}
                            <div className="col-lg-3 mb-2">
                              <Select
                                isMulti
                                options={sector}
                                value={sector.filter((item) =>
                                  surveyData.target_sector?.some(
                                    (sel) =>
                                      sel.answer.trim() === item.answer.trim()
                                  )
                                )}
                                onChange={(selected) =>
                                  setSurveyData({
                                    ...surveyData,
                                    target_sector: selected,
                                  })
                                }
                                getOptionLabel={(e) => e.answer.trim()}
                                getOptionValue={(e) => e.answer.trim()}
                                styles={customStyles}
                                placeholder="Sector"
                                classNamePrefix="react-select"
                                components={{
                                  ValueContainer: CustomValueContainer,
                                }}
                              />

                              {/* <select
                                className="form-select"
                                multiple
                                value={sector}
                                onChange={(e) =>
                                  handleMultiSelect(e, setSector)
                                }
                                data-placeholder="Sector"
                              >
                                {sector.map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.answer.trim()}
                                  >
                                    {item.answer.trim()}
                                  </option>
                                ))}
                              </select> */}
                            </div>
                            <div className="col-lg-3 mb-2">
                              {/* industry  */}
                              <Select
                                isMulti
                                options={industry}
                                value={industry.filter((item) =>
                                  surveyData.target_industry.some(
                                    (sel) =>
                                      sel.answer.trim() === item.answer.trim()
                                  )
                                )}
                                onChange={(selected) => {
                                  console.clear();
                                  console.log(
                                    "Change event triggered of industry"
                                  );
                                  setSurveyData({
                                    ...surveyData,
                                    target_industry: selected,
                                  });
                                }}
                                getOptionLabel={(e) => e.answer.trim()}
                                getOptionValue={(e) => e.answer.trim()}
                                styles={customStyles}
                                placeholder="Industry"
                                classNamePrefix="react-select"
                                components={{
                                  ValueContainer: CustomValueContainer,
                                }}
                              />
                            </div>
                            {/* Region  */}
                            <div className="col-lg-3 mb-2">
                              <Select
                                isMulti
                                options={region}
                                value={region.filter((item) =>
                                  surveyData.target_region.some(
                                    (sel) =>
                                      sel.answer.trim() === item.answer.trim()
                                  )
                                )}
                                onChange={(selected) => {
                                  console.clear();
                                  console.log(
                                    "Change event triggered of industry"
                                  );
                                  setSurveyData({
                                    ...surveyData,
                                    target_region: selected,
                                  });
                                }}
                                getOptionLabel={(e) => e.answer.trim()}
                                getOptionValue={(e) => e.answer.trim()}
                                styles={customStyles}
                                placeholder="Region"
                                classNamePrefix="react-select"
                                components={{
                                  ValueContainer: CustomValueContainer,
                                }}
                              />
                            </div>

                            {/* Country  */}
                            <div className="col-lg-3 mb-2">
                              <Select
                                isMulti
                                options={country}
                                value={country.filter((item) =>
                                  surveyData.target_country.some(
                                    (sel) =>
                                      sel.answer.trim() === item.answer.trim()
                                  )
                                )}
                                onChange={(selected) => {
                                  setSurveyData({
                                    ...surveyData,
                                    target_country: selected,
                                  });
                                }}
                                getOptionLabel={(e) => e.answer.trim()}
                                getOptionValue={(e) => e.answer.trim()}
                                styles={customStyles}
                                placeholder="Country"
                                classNamePrefix="react-select"
                                components={{
                                  ValueContainer: CustomValueContainer,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-lg-6">
                            <label className="form-label">Start Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={surveyData.start_date}
                              onChange={(e) => {
                                if (
                                  surveyData.end_date &&
                                  e.target.value > surveyData.end_date
                                ) {
                                  toast.error(
                                    "Start Date cannot be later than End Date"
                                  );
                                  return;
                                }
                                setSurveyData((prev) => ({
                                  ...prev,
                                  start_date: e.target.value,
                                }));
                              }}
                            />
                          </div>

                          <div className="col-lg-6">
                            <label className="form-label">End Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={surveyData.end_date}
                              onChange={(e) => {
                                if (
                                  surveyData.start_date &&
                                  e.target.value < surveyData.start_date
                                ) {
                                  toast.error(
                                    "End Date cannot be earlier than Start Date"
                                  );
                                  return;
                                }
                                setSurveyData((prev) => ({
                                  ...prev,
                                  end_date: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>

                        <div id="question_setup" className="mt-5">
                          <h4 className="d-flex mb-4">
                            <span>
                              <i className="bi bi-question-circle"></i>
                            </span>
                            <span className="ms-2">Survey Questions Setup</span>
                          </h4>
                          <div id="question_listing">
                            {surveyData.questions.map((question, index) => (
                              <div
                                className="question_list"
                                key={index}
                                ref={(el) =>
                                  (questionListRef.current[index] = el)
                                }
                              >
                                <div className="row">
                                  <div className="col-9">
                                    <div className="mb-4">
                                      <input
                                        type="text"
                                        className="form-control questionText"
                                        placeholder="Type your survey question here"
                                        value={question.question}
                                        onChange={(e) =>
                                          updateQuestion(
                                            index,
                                            "question",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="option_type_append">
                                      {renderQuestionOptions(question, index)}
                                    </div>
                                  </div>
                                  <div className="col-3">
                                    <div className="question_type">
                                      <div
                                        className="question_type_label d-flex justify-content-between ft-14"
                                        onClick={() => {
                                          setOpenDropdownIndex(
                                            openDropdownIndex === index
                                              ? null
                                              : index
                                          );
                                        }}
                                      >
                                        <div className="question_type_label_replace">
                                          {question.question_type ===
                                            "openend" && (
                                              <>
                                                <i className="bi bi-clipboard me-2"></i>
                                                Open End
                                              </>
                                            )}
                                          {/* {question.type === "dropdown" && <><i className="bi bi-caret-down-square me-2"></i>Drop Down</>} */}
                                          {question.question_type ===
                                            "multipleChoice" && (
                                              <>
                                                <i className="bi bi-check-square me-2"></i>
                                                Multiple Choice
                                              </>
                                            )}
                                          {question.question_type ===
                                            "singleChoice" && (
                                              <>
                                                <i className="bi bi-circle-fill me-2"></i>
                                                Single Choice
                                              </>
                                            )}
                                          {question.question_type ===
                                            "ratings" && (
                                              <>
                                                <i className="bi bi-star me-2"></i>
                                                Ratings
                                              </>
                                            )}
                                          {question.question_type ===
                                            "scaling" && (
                                              <>
                                                <i className="bi bi-sliders me-2"></i>
                                                Scaling
                                              </>
                                            )}
                                        </div>
                                        <i
                                          className={`bi ${openDropdownIndex === index
                                              ? "bi-chevron-up"
                                              : "bi-chevron-down"
                                            }`}
                                        ></i>
                                      </div>
                                      <div
                                        className="question_type_label_option"
                                        style={{
                                          display:
                                            openDropdownIndex === index
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <ul className="list-unstyled mb-0 p-0 ft-14">
                                          <li
                                            onClick={() => {
                                              updateQuestion(
                                                index,
                                                "question_type",
                                                "openend"
                                              );
                                              setOpenDropdownIndex(null);
                                            }}
                                          >
                                            Open End
                                          </li>

                                          <li
                                            onClick={() => {
                                              updateQuestion(
                                                index,
                                                "question_type",
                                                "multipleChoice"
                                              );
                                              setOpenDropdownIndex(null);
                                            }}
                                          >
                                            Multiple Choice
                                          </li>

                                          <li
                                            onClick={() => {
                                              updateQuestion(
                                                index,
                                                "question_type",
                                                "singleChoice"
                                              );
                                              setOpenDropdownIndex(null);
                                            }}
                                          >
                                            Single Choice
                                          </li>

                                          <li
                                            onClick={() => {
                                              updateQuestion(
                                                index,
                                                "question_type",
                                                "ratings"
                                              );
                                              setOpenDropdownIndex(null);
                                            }}
                                          >
                                            Ratings
                                          </li>

                                          <li
                                            onClick={() => {
                                              updateQuestion(
                                                index,
                                                "question_type",
                                                "scaling"
                                              );
                                              setOpenDropdownIndex(null);
                                            }}
                                          >
                                            Scaling
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex question_list_action justify-content-end gap-4 ft-18">
                                  <a
                                    href="#"
                                    className="text-decoration-none add_new_question"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      addNewQuestion();
                                    }}
                                  >
                                    <i className="bi bi-plus-circle"></i>
                                  </a>
                                  <a
                                    href="#"
                                    className="text-decoration-none clone_this_question"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      cloneQuestion(index);
                                    }}
                                  >
                                    <i className="bi bi-copy"></i>
                                  </a>
                                  <a
                                    href="#"
                                    className="text-decoration-none delete_this_question"
                                    style={{
                                      display:
                                        surveyData.questions.length > 1
                                          ? "inline-block"
                                          : "none",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      deleteQuestion(index);
                                    }}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </a>
                                </div>
                                <hr />
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="create_survey_button_box d-flex justify-content-between align-items-center mt-5">
                          <div className="d-flex gap-3">
                            <button
                              type="button"
                              className="btn btn-outline-dark text-decoration-none draft_survey rounded-3 ft-15"
                              onClick={(e) => handleSubmit2(e, 2)}
                              disabled={loading}
                            >
                              <i className="bi bi-bookmark m-0"></i> Save as
                              Draft
                            </button>
                            <a
                              href="#"
                              className="btn btn-outline-dark text-decoration-none clear_all_survey rounded-3 ft-15"
                              onClick={(e) => {
                                e.preventDefault();
                                resetSurvey();
                              }}
                            >
                              Clear All
                            </a>
                          </div>
                          <div className="d-flex gap-3">
                            <a
                              href="#"
                              className="btn btn-outline-dark text-decoration-none preview_survey rounded-3 ft-15 d-flex justify-content-center align-items-center gap-2"
                            >
                              Preview Survey{" "}
                              <i className="bi bi-eye-fill m-0"></i>
                            </a>
                            <button
                              type="submit"
                              className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                              disabled={loading}
                            >
                              Create Survey
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Survey;
